import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ieltsPath } from "./ieltsMocks";

const MOCKS = [1, 2, 3, 4, 5, 6, 7];

const MODULES = [
    { module: "reading", label: "Reading", icon: "menu_book", meta: "3 Passages • 40 Questions • 60 Min" },
    { module: "listening", label: "Listening", icon: "headphones", meta: "4 Sections • 40 Questions • 32 Min" },
    { module: "writing", label: "Writing", icon: "edit_square", meta: "2 Tasks • Analysis & Essay • 60 Min" },
    { module: "speaking", label: "Speaking", icon: "mic", meta: "3 Parts • Face-to-Face • 11-14 Min" },
];

export default function IeltsMenu() {
    const navigate = useNavigate();
    // No mock selected until one is clicked; the module cards stay hidden until then.
    const [mock, setMock] = useState(null);

    return (
        <div className="min-h-screen bg-background-dark text-white font-display p-8 flex flex-col items-center justify-center">
            <style>{`
                @keyframes ielts-menu-in {
                    from { opacity: 0; translate: 0 16px; }
                    to   { opacity: 1; translate: 0 0; }
                }
                .ielts-menu-card { opacity: 0; animation: ielts-menu-in 0.4s ease forwards; }
                @media (prefers-reduced-motion: reduce) {
                    .ielts-menu-card { animation: none; opacity: 1; }
                }
            `}</style>

            <h1 className="text-5xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-emerald-300 mb-4">IELTS Mock Test</h1>
            <p className="text-gray-400 mb-8 text-lg">
                {mock ? `Mock ${mock}: select a module to begin your assessment.` : "Select a mock test to begin."}
            </p>

            {/* MOCK BUTTONS */}
            <div className="flex flex-wrap justify-center gap-3 mb-10" role="tablist" aria-label="IELTS mock test">
                {MOCKS.map((m) => {
                    const active = mock === m;
                    return (
                        <button
                            key={m}
                            role="tab"
                            aria-selected={active}
                            // Clicking the open mock again hides its modules.
                            onClick={() => setMock(active ? null : m)}
                            className={`min-w-[110px] px-6 py-3 rounded-xl font-bold border-2 border-[#19fd91] transition-all duration-200 active:scale-90 ${
                                active
                                    ? "bg-[#19fd91] text-black shadow-[0_6px_20px_rgba(25,253,145,0.35)] scale-105"
                                    : "bg-transparent text-[#19fd91] hover:bg-[#19fd91]/10"
                            }`}
                        >
                            Mock {m}
                        </button>
                    );
                })}
            </div>

            {mock && (
                // Re-keyed per mock so the cards slide in again on every switch.
                <div key={mock} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl w-full">
                    {MODULES.map((mod, idx) => (
                        <div
                            key={mod.module}
                            onClick={() => navigate(ieltsPath(mock, mod.module, "/intro"))}
                            style={{ animationDelay: `${idx * 70}ms` }}
                            className="ielts-menu-card group p-1 rounded-3xl bg-gradient-to-br from-white/10 to-transparent hover:from-[#19fd91]/50 hover:to-[#19fd91]/20 cursor-pointer transition-all duration-300 transform hover:-translate-y-2"
                        >
                            <div className="bg-card-dark p-8 rounded-[22px] h-full flex flex-col items-center text-center group-hover:bg-black/80 transition-all">
                                <span className="material-symbols-outlined text-5xl text-gray-300 group-hover:text-[#19fd91] mb-4 transition-colors">{mod.icon}</span>
                                <h2 className="text-2xl font-bold mb-2">{mod.label}</h2>
                                <p className="text-sm text-gray-500 group-hover:text-gray-300">{mod.meta}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <button onClick={() => navigate("/tests")} className="mt-12 text-gray-500 hover:text-white transition-colors">← Back to Dashboard</button>
        </div>
    );
}
